import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IAdminWallet, IAdminWalletInitialState } from "./adminWalletUserModel";
import {
  getAllAdminWalletUsers,
  getAllWalletTransactionUserWise,
} from "./services/adminWalletUser.services";

const initialState: IAdminWalletInitialState = {
  loading: false,
  error: "",
  AdminWalletList: [],
  AdminWalletID: null,
  WalletTransactionDetails: {},
  FilterAdminWallet: {
    UserName: "",
    mobile_no: "",
    email_id: "",
    wallet_createdon: "",
  },
};

const adminWalletUserSlice = createSlice({
  name: "adminWalletUser",
  initialState,
  reducers: {
    setAdminWalletID: (state, action) => {
      state.AdminWalletID = action.payload;
    },
    clearAdminWalletID: (state) => {
      state.AdminWalletID = initialState.AdminWalletID;
    },
    setFilterAdminWallet: (state, action) => {
      state.FilterAdminWallet = action.payload;
    },
    clearFilterAdminWallet: (state) => {
      state.FilterAdminWallet = initialState.FilterAdminWallet;
    },
    clearWalletTransactionDetails: (state) => {
      state.WalletTransactionDetails = initialState.WalletTransactionDetails;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getAllAdminWalletUsers.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(
      getAllAdminWalletUsers.fulfilled,
      (state, action: PayloadAction<IAdminWallet[]>) => {
        state.loading = false;
        state.AdminWalletList = action.payload || [];
      }
    );
    builder.addCase(getAllAdminWalletUsers.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
      state.AdminWalletList = [];
    });

    builder.addCase(getAllWalletTransactionUserWise.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(
      getAllWalletTransactionUserWise.fulfilled,
      (state, action: PayloadAction<any>) => {
        state.loading = false;
        state.WalletTransactionDetails = action.payload;
      }
    );
    builder.addCase(
      getAllWalletTransactionUserWise.rejected,
      (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Something went wrong";
        state.WalletTransactionDetails = initialState.WalletTransactionDetails;
      }
    );
  },
});

export const {
  clearAdminWalletID,
  setAdminWalletID,
  clearFilterAdminWallet,
  setFilterAdminWallet,
  clearWalletTransactionDetails,
} = adminWalletUserSlice.actions;
export default adminWalletUserSlice.reducer;
